<div id="main-wrapper" [ngClass]="{'menu-toggle':toggleVal, 'show':true}" [class.iconhover-toggle]="mouseOvered">
  
  <!--**** Nav header start ********-->
  <app-nav-header (sidebarToggle)=sidebarToggle($event)></app-nav-header>
  <!--******* Nav header end ***********-->
  
  <!--********** Header start **********-->
  <app-header></app-header>
  <!--*********  Header end ************-->
  
  <!--********* Sidebar start **********-->
  <app-sidebar (mouseHoverEvent)="iconHoverToggle($event)" />
  <!--********* Sidebar end **********-->
  <div class="spinner-container" *ngIf="loadingService.isLoading()">
    <mat-spinner></mat-spinner>
  </div>
  
  <!--******** Content body start *******-->
  <router-outlet></router-outlet>
  <!--******** Content body end *********-->
  
  <app-footer></app-footer>

  <!-- DB Query Agent chat panel: mounted once so it persists across routes -->
  <app-agent-chat></app-agent-chat>
  </div>
